var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 560,
    viewBox: "0 0 390 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 543C76.1 543.467 80.2 543.91 84.3 544.33C121.2 548.11 158.1 550 195 550C231.9 550 268.8 548.11 305.7 544.33C309.8 543.91 313.9 543.467 318 543C313.9 542.533 309.8 542.09 305.7 541.67C268.8 537.89 231.9 536 195 536C158.1 536 121.2 537.89 84.3 541.67C80.2 542.09 76.1 542.533 72 543Z",
    fill: "#FFDA8B",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 543C103.167 543.333 106.333 543.65 109.5 543.95C138 546.65 166.5 548 195 548C223.5 548 252 546.65 280.5 543.95C283.667 543.65 286.833 543.333 290 543C286.833 542.667 283.667 542.35 280.5 542.05C252 539.35 223.5 538 195 538C166.5 538 138 539.35 109.5 542.05C106.333 542.35 103.167 542.667 100 543Z",
    fill: "url(#paint0_linear_12682_3517)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 543C132.167 543.133 134.333 543.26 136.5 543.38C156 544.46 175.5 545 195 545C214.5 545 234 544.46 253.5 543.38C255.667 543.26 257.833 543.133 260 543C257.833 542.867 255.667 542.74 253.5 542.62C234 541.54 214.5 541 195 541C175.5 541 156 541.54 136.5 542.62C134.333 542.74 132.167 542.867 130 543Z",
    fill: "url(#paint1_linear_12682_3517)",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.5971 -0.500553L19.5824 -33.2148L246.918 281.402L136.067 345.402L-16.5971 -0.500553Z",
    fill: "url(#paint2_linear_12682_3517)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5872 110.541C144.736 188.742 161.419 263.636 161.419 263.636C161.419 263.636 104.899 211.742 59.75 133.541C14.6007 55.3405 -13.0821 -13.2026 -2.08142 -19.5538C8.91931 -25.9051 54.4379 32.3405 99.5872 110.541Z",
    fill: "url(#paint3_linear_12682_3517)",
    fillOpacity: 0.35
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8647 38.349C68.8181 76.3733 74.0574 114.448 74.0574 114.448C74.0574 114.448 43.7033 90.8733 21.75 52.849C-0.203318 14.8248 -12.3779 -19.2459 -5.44263 -23.25C1.49261 -27.2541 24.9114 0.324757 46.8647 38.349Z",
    fill: "url(#paint4_linear_12682_3517)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.515 -0.500553L380.336 -33.2148L153 281.402L263.851 345.402L416.515 -0.500553Z",
    fill: "url(#paint5_linear_12682_3517)",
    fillOpacity: 0.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.331 110.541C255.182 188.742 238.5 263.636 238.5 263.636C238.5 263.636 295.019 211.742 340.168 133.541C385.317 55.3405 413 -13.2026 402 -19.5538C390.999 -25.9051 345.48 32.3405 300.331 110.541Z",
    fill: "url(#paint6_linear_12682_3517)",
    fillOpacity: 0.35
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_12682_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.082 38.349C333.129 76.3733 327.89 114.448 327.89 114.448C327.89 114.448 358.244 90.8733 380.197 52.849C402.15 14.8248 414.325 -19.2459 407.39 -23.25C400.454 -27.2541 377.036 0.324757 355.082 38.349Z",
    fill: "url(#paint7_linear_12682_3517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12682_3517",
    x: 56,
    y: 520,
    width: 278,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12682_3517",
    x: 90,
    y: 528,
    width: 210,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_12682_3517",
    x: 124,
    y: 535,
    width: 142,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_12682_3517",
    x: -40.5972,
    y: -57.2148,
    width: 311.515,
    height: 426.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_12682_3517",
    x: -32.4924,
    y: -48.0276,
    width: 221.911,
    height: 339.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_12682_3517",
    x: -27.3901,
    y: -43.6362,
    width: 121.448,
    height: 178.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_12682_3517",
    x: 129,
    y: -57.2148,
    width: 311.515,
    height: 426.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_12682_3517",
    x: 210.5,
    y: -48.0276,
    width: 221.911,
    height: 339.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_12682_3517",
    x: 307.89,
    y: -43.6362,
    width: 121.448,
    height: 178.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_12682_3517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12682_3517",
    x1: 114.812,
    y1: 543,
    x2: 290,
    y2: 543.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12682_3517",
    x1: 130,
    y1: 543.5,
    x2: 260,
    y2: 543.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12682_3517",
    x1: 3.99265,
    y1: -11.3577,
    x2: 205.694,
    y2: 338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6CB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12682_3517",
    x1: -2.08142,
    y1: -19.5538,
    x2: 161.419,
    y2: 263.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12682_3517",
    x1: -5.44263,
    y1: -23.25,
    x2: 63.4064,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE89",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12682_3517",
    x1: 395.926,
    y1: -11.3577,
    x2: 194.224,
    y2: 338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6CB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12682_3517",
    x1: 402,
    y1: -19.5538,
    x2: 238.5,
    y2: 263.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12682_3517",
    x1: 407.39,
    y1: -23.25,
    x2: 332.767,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE89",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardLight);
export default __webpack_public_path__ + "static/media/reward-light.61706ffed1c987354dd476cc28c5eab5.svg";
export { ForwardRef as ReactComponent };